import { SurveyService } from '@/services/survey.service'

export const actions = {
  setSurveyAccountId({ commit }, surveyAccountId) {
    commit('SET_SURVEY_ACCOUNT_ID', surveyAccountId)
  },

  setSurveySelectedUnit({ commit }, surveySelectedUnit = null) {
    commit('SET_SURVEY_SELECTED_UNIT', surveySelectedUnit)
  },

  setSurveyUserId({ commit }, surveyUserId = null) {
    commit('SET_SURVEY_USER_ID', surveyUserId)
  },

  setSurveyFavoriteUnitId({ commit }, surveyFavoriteUnitId = null) {
    commit('SET_SURVEY_FAVORITE_UNIT_ID', surveyFavoriteUnitId)
  },

  async fetchSurveyPublicDetails({ getters, commit }, surveyId) {
    try {
      const surveyService = new SurveyService(getters.GET_SURVEY_ACCOUNT_ID)
      const surveyPublicDetails = await surveyService.fetchPublicDetails(surveyId)

      commit('SET_SURVEY_PUBLIC_DETAILS', surveyPublicDetails)
    } catch (error) {
      throw error
    }
  },

  async authenticateUserFromSurvey({ getters, commit }, { surveyId, userId, turnstileCode }) {
    try {
      const surveyService = new SurveyService(getters.GET_SURVEY_ACCOUNT_ID)
      const response = await surveyService.authenticateUserFromSurvey(surveyId, userId, turnstileCode)

      commit('SET_SURVEY_TOKEN', response.token)
      if (response.userId) {
        commit('SET_SURVEY_USER_ID', response.userId)
      }
    } catch (error) {
      throw error
    }
  },

  async fetchConsumerFavoriteUnit({ getters }, { surveyId, userId }) {
    const surveyService = new SurveyService(getters.GET_SURVEY_ACCOUNT_ID)
    return surveyService.fetchConsumerFavoriteUnit(surveyId, userId)
  },

  async authenticateUserFromShortCode({ getters, commit, dispatch }, { shortCode, turnstileCode }) {
    try {
      const surveyService = new SurveyService(getters.GET_SURVEY_ACCOUNT_ID)
      const response = await surveyService.authenticateUserFromShortCode(shortCode, turnstileCode)

      commit('SET_SURVEY_TOKEN', response.token)
      if (response.userId) {
        commit('SET_SURVEY_USER_ID', response.userId)
      }
      dispatch('setSurveyFavoriteUnitId', response.favoriteUnitId != null ? response.favoriteUnitId : null)
      return response.survey._id
    } catch (error) {
      throw error
    }
  }
}
